import { Routes } from "@angular/router";
import { authGuard } from "./shared/guards/auth.guard";
import { environment } from "../environments/environment";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: () =>
      import("./login/login.component").then((m) => m.LoginComponent),
  },
  {
    path: "admin/viper/recap",
    redirectTo: "viper/recap",
    pathMatch: "full",
  },
  {
    path: "viper/recap",
    canActivate: environment.viperRecapAuthDisabled ? [] : [authGuard],
    loadComponent: () =>
      import("./viper/admin-recap/viper-recap.component").then(
        (m) => m.ViperRecapComponent,
      ),
  },
  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./home/routes/home.routes").then((r) => r.HOME_ROUTES),
  },
  {
    path: "banners",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./banners/routes/banner.routes").then((r) => r.BANNER_ROUTES),
  },
  {
    path: "users",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./users/routes/users.routes").then((r) => r.USERS_ROUTES),
  },
  {
    path: "subscriptions",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./subscriptions/routes/subscriptions.routes").then((r) => r.SUBSCRIPTIONS_ROUTES),
  },
  {
    path: "products",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./products/routes/products.routes").then((r) => r.PRODUCTS_ROUTES),
  },
  {
    path: "wins",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./wins/routes/win.routes").then((r) => r.WINS_ROUTES),
  },
  {
    path: "testimonials",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./testimonials/routes/testimonials.routes").then(
        (r) => r.TESTIMONIAL_ROUTES,
      ),
  },
  {
    path: "announcements",
    canActivate: [authGuard],
    loadChildren: () =>
      import("./announcements-modal/routes/announcements.routes").then(
        (r) => r.ANNOUNCEMENTS_ROUTES,
      ),
  },
];
